import {translations} from 'presentation/translations-new';
import {Theme} from '@mui/material';
import {ReferralStatusEnum} from 'domain/usecases/private/my-referrals-flow/get-referrals';
import {formatText} from 'presentation/utils';
import {CardStyleByStatusType} from '../types';

const {status: statusCard} = translations['pt-br'].privateFlow.myReferrals;

export const cardStyleByStatus = (theme: Theme, status: ReferralStatusEnum) => {
	const parsedStatus = status.toUpperCase() as ReferralStatusEnum;
	const styles: CardStyleByStatusType = {
		[ReferralStatusEnum.SUCCESS]: {
			borderColor: theme.palette.success.main,
			chipVariant: 'success',
			chipText: statusCard.success,
		},
		[ReferralStatusEnum.REJECTED]: {
			borderColor: theme.palette.error.main,
			chipVariant: 'error',
			chipText: statusCard.rejected,
		},
		[ReferralStatusEnum.PENDING]: {
			borderColor: theme.colors.light.warning.main!,
			chipVariant: 'warning',
			chipText: statusCard.pending,
		},
		[ReferralStatusEnum.SCHEDULED]: {
			borderColor: theme.palette.success.main,
			chipVariant: 'success',
			chipText: statusCard.scheduled,
		},

		[ReferralStatusEnum.FINISHED]: {
			borderColor: theme.palette.success.main,
			chipVariant: 'success',
			chipText: statusCard.finished,
		},
		[ReferralStatusEnum.UNDER_ANALYSIS]: {
			borderColor: theme.colors.light.info.main as string,
			chipVariant: 'info',
			chipText: statusCard.underAnalysis,
			chipTextColor: theme.colors.light.info.dark as string,
		},
	};

	const defaultStyles: CardStyleByStatusType[ReferralStatusEnum] = {
		borderColor: theme.palette.text.disabled,
		chipVariant: 'success',
		chipText: formatText(status),
	};

	return styles[parsedStatus] || defaultStyles;
};
